const currentYear = new Date().getFullYear();

const locale = {
    code: "zh",
    label: "中文",
    LANGUAGE_LABEL: "选择语言",
    NAV_BAR: {
        home: "首页",
        homeId: "home",
        aboutus: "关于我们",
        aboutId: "aboutus",
        faq: "常见问题",
        faqId: "faq-section",
        contact: "联系",
        contactId: "contact-section",
        button: "获取提前访问",
    },

    HERO: {
        heroHeading: "您的菜单，即刻可用",
        heroParagraph:
            "只需一个二维码即可创建、更新并分享您的菜单——无需麻烦，无需重新打印。",
        button: "获取提前访问",
        downloadText: "下载于",
        appStore: "App Store",
        getItOn: "获取",
        googlePlay: "Google Play",
    },

    SERVICES: {
        heading: "我们的服务",
        cards: [
            {
                title: "创建并上传菜单",
                description:
                    "只需几次点击即可轻松创建并上传您的菜单！添加项目、设置价格，并轻松更新详细信息，无需技术技能。",
            },
            {
                title: "更新菜单",
                description:
                    "随时随地实时更新您的菜单！更改价格、添加新菜或立即存档不可用餐品，无需重新打印。",
            },
            {
                title: "生成并共享",
                description:
                    "立即生成唯一的二维码！将其放在桌子、海报或在线分享，让客户轻松扫描并访问您最新的菜单。",
            },
        ],
    },

    FEATURES: {
        heading: "探索我们的精彩功能",
        lists: [
            {
                title: "管理菜单",
                description:
                    "随时管理您的菜单！轻松添加、编辑或删除项目，让您的产品保持新鲜并与客户同步。",
            },
            {
                title: "洞察与报告",
                description:
                    "通过实时报告获得有价值的洞察！跟踪菜单浏览、二维码扫描和客户互动。",
            },
            {
                title: "共享二维码",
                description:
                    "使用唯一二维码共享您的菜单！将其展示在桌子、海报或在线，让客户立即扫描并访问最新菜单。",
            },
            {
                title: "客户评价",
                description:
                    "展示客户反馈和真实评分！建立信任，改进菜单，并提升用餐体验。",
            },
            {
                title: "优惠与折扣",
                description:
                    "通过特别优惠和折扣提升销售！突出促销、限时特惠和独家折扣，吸引并留住更多客户。",
            },
        ],
    },

    ABOUT: {
        heading: "关于 My QR Menu",
        headingPara: "通过实时更新简化您的餐厅菜单管理。",
        highlightHeading: "快速、轻松访问您所需的一切",
        highlightPara: "所有菜单功能 — 只需轻触一次即可。",
        cards: {
            left: {
                heading: ["轻松添加配料", "到您的二维码菜单"],
                alt: "添加配料",
            },
            right: {
                heading: ["轻松访问", "菜单仪表板"],
                alt: "菜单仪表板",
            },
        },
    },

    FAQ: {
        heading: "您有问题，我们有答案。",
        subheading: "您需要了解的产品信息。",
        items: [
            {
                question: "什么是 My QRMenu？",
                answer:
                    "My QRMenu 是一个数字菜单平台，使餐厅能够通过二维码即时创建、更新和共享菜单。",
            },
            {
                question: "创建后我可以更新菜单吗？",
                answer:
                    "是的，您可以随时更新您的菜单，客户扫描二维码后会立即看到最新内容。",
            },
            {
                question: "My QRMenu 如何运作？",
                answer:
                    "您创建菜单、生成二维码，客户扫描后即可查看最新菜单。",
            },
            {
                question: "我如何共享我的二维码？",
                answer:
                    "您可以通过数字方式共享二维码，或打印展示在餐厅中。",
            },
            {
                question: "My QRMenu 支持移动设备吗？",
                answer:
                    "是的，My QRMenu 针对所有设备进行了优化，包括手机和平板。",
            },
            {
                question: "我可以收集客户评价吗？",
                answer:
                    "是的，您可以启用客户评价并使用反馈改进产品。",
            },
        ],
    },

    CONTACT: {
        heading: "联系我们",
        subheading: "我们的团队愿为您提供帮助。",
        firstName: "名字",
        lastName: "姓氏",
        email: "电子邮件",
        message: "消息",
        firstNamePlaceholder: "名字",
        lastNamePlaceholder: "姓氏",
        emailPlaceholder: "你@公司.com",
        messagePlaceholder: "写下您的消息...",
        privacyConsent: "您同意我们的",
        privacyPolicy: "隐私政策",
        submitButton: "发送消息",
        toast: {
            requiredConsent: "您必须同意隐私政策。",
            submitting: "正在提交消息...",
            success: "消息发送成功！",
            fail: "消息发送失败。请再试一次。",
            error: "发生错误。请检查您的网络连接。",
        },
    },

    HELP_PAGE: {
        title: "帮助中心",
        description: "如果您有任何问题或需要支持，请通过以下方式联系我们：",
        contactEmail: "contact@myqrmenu.co",
        faqPrompt: "或者浏览下面的常见问题，您可能会找到所需的答案。",
    },

    FOOTER: {
        footerHeading: "无缝数字菜单，简单高效！",
        footerButton: "加入候补名单",
        footerConnect: "与我们连接",
        footerTerms: "条款与协议",
        footerHelp: "帮助中心",
        footerPrivacy: "隐私政策",
        footerCopyright: `©${currentYear} 版权所有。`,
    },

    PRIVACY_POLICY: {
        title: "隐私政策",
        lastUpdated: "最后更新：2025年5月22日",
        content: `
            <article class="mb-12">
                <p class="mb-6 leading-relaxed">
                本隐私政策描述了我们在您使用服务时收集、使用和披露您的信息的政策和程序。
                </p>
                <p class="mb-6 leading-relaxed">
                我们使用您的个人数据来提供和改进服务。通过使用服务，您同意按照本隐私政策收集和使用信息。
                </p>
            </article>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">解释与定义</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-2">解释</h3>
                <p class="mb-6 leading-relaxed">
                    首字母大写的单词在下列条件下具有定义的含义。
                </p>
                </article>

                <article>
                <h3 class="text-xl font-semibold mb-4">定义</h3>
                <ul class="list-disc list-inside mb-6 space-y-3 text-gray-800">
                    <li><strong>账户</strong> 指为您访问我们的服务而创建的唯一账户。</li>
                    <li><strong>公司</strong> 指 <strong>My QR Menu,</strong> 英国伦敦。</li>
                    <li><strong>个人数据</strong> 是与已识别或可识别的个人相关的任何信息。</li>
                    <li><strong>您</strong> 指访问或使用服务的个人。</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <h2 class="text-2xl font-semibold mb-6">联系我们</h2>
                <p>
                如果您对本隐私政策有任何疑问，可以联系我们：
                </p>
                <ul class="list-disc list-inside mt-2">
                <li>通过电子邮件： <a href="mailto:hello@myqrmenu.co" class="text-gray-800 underline">hello@myqrmenu.co</a></li>
                </ul>
            </section>
        `
    },

    TERMS_AND_CONDITIONS: {
        title: "条款与条件",
        lastUpdated: "最后更新：2025年5月22日",
        content: `
            <p class="leading-relaxed mb-6">
            在使用我们的应用程序或网站之前，请仔细阅读这些条款与条件。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">1. 解释与定义</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">解释</h3>
            <p class="leading-relaxed mb-4">
            首字母大写的单词在以下条件下具有定义的含义。
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">定义</h3>
            <ul class="list-disc list-inside mb-6 leading-relaxed text-gray-800">
            <li><strong>应用程序</strong> 是指由 My QR Menu 提供的软件。</li>
            <li><strong>公司</strong> 指位于英国伦敦的 My QR Menu。</li>
            <li><strong>服务</strong> 指应用程序和网站。</li>
            <li><strong>您</strong> 指访问或使用服务的个人或企业。</li>
            </ul>

            <h2 class="text-2xl font-semibold mt-10 mb-4">2. 确认</h2>
            <p class="leading-relaxed mb-6">
            通过访问或使用服务，您同意受这些条款的约束。如果您不同意任何部分，则不得访问服务。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">3. 第三方网站链接</h2>
            <p class="leading-relaxed mb-6">
            我们的服务可能包含指向第三方网站的链接。我们不对其内容或行为负责。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">4. 终止</h2>
            <p class="leading-relaxed mb-6">
            我们保留因任何原因立即终止或暂停您访问服务的权利，无需事先通知。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">5. 责任限制</h2>
            <p class="leading-relaxed mb-6">
            在法律允许的最大范围内，公司不对因您使用服务而产生的任何损害负责。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">6. “按原样”和“可用”免责声明</h2>
            <p class="leading-relaxed mb-6">
            服务是按“原样”和“可用”基础提供给您的。我们不保证服务无错误或不会中断。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">7. 准据法</h2>
            <p class="leading-relaxed mb-6">
            这些条款受英国法律管辖。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">8. 争议解决</h2>
            <p class="leading-relaxed mb-6">
            如果您与我们有争议，您同意在采取法律行动之前尝试非正式解决。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">9. 欧盟 (EU) 用户</h2>
            <p class="leading-relaxed mb-6">
            如果您是欧盟消费者，您享有居住国法律强制性规定的保护。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">10. 美国法律合规性</h2>
            <p class="leading-relaxed mb-6">
            您声明并保证您不位于受美国政府制裁的国家。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">11. 可分割性与放弃</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">可分割性</h3>
            <p class="leading-relaxed mb-4">
            如果本条款的任何规定被判定为不可执行，其余规定将继续有效。
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">放弃</h3>
            <p class="leading-relaxed mb-6">
            未行使某项权利不构成对该权利的放弃。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">12. 翻译解释</h2>
            <p class="leading-relaxed mb-6">
            这些条款可能已被翻译。如有争议，以英文版本为准。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">13. 条款变更</h2>
            <p class="leading-relaxed mb-6">
            我们可以随时更新这些条款。我们将通过在网站上发布通知来通知您。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">14. 联系我们</h2>
            <p class="leading-relaxed mb-2">如果您对这些条款有任何疑问，可以联系我们：</p>
            <ul class="list-disc list-inside text-gray-800">
            <li>电子邮件： <a href="mailto:hello@myqrmenu.co" class="text-blue-600 underline">hello@myqrmenu.co</a></li>
            </ul>
        `
    }
};

export default locale;
